import React from 'react';
import ReactDOM from 'react-dom';
import Nav from 'components/Nav';
import App from './App';
import 'normalize.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
// import ModalEmail from 'components/ModalEmail';

ReactDOM.render(
  <React.StrictMode>
    <Nav />
    <App />
    {/* <ModalEmail /> */}
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
